<template>
    <div>
        <section class="video-card">

            <div class="video-card-wrapper" @click="clickAction">
                <div class="top">
                    <div class="image">
                        <img :src="require(`@/assets/img/${headshot}`)" alt="Speaker headshot" />
                    </div>
                    <div class="content">
                        <span class="video-title">{{ title }}</span>
                        <p>{{ byline }}</p>
                    </div>
                </div>

                <div class="bottom">
                    <div class="icon">
                        <img src="@/assets/img/play-btn.svg" alt="Play button" />
                    </div>
                    <div class="content">
                        <p v-html="videoCta"></p>
                    </div>
                </div>

            </div>

        </section>
        <VimeoModal :videoId="videoID" :isOpen.sync="videoIsOpen" channel="vimeo" />
    </div>
</template>

<script>
import VimeoModal from '../VimeoModal.vue';

export default {
    props: ['title', 'byline', 'videoCta', 'headshot', 'videoID', 'type', 'url'],
    components: {
        VimeoModal
    },
    data() {
        return {
            videoIsOpen: false
        }
    },
    methods: {
        openVideo() {
            this.videoIsOpen = !this.videoIsOpen
        },
        clickAction() {
            if (this.type == 'link') {
                window.location = this.url;
            } else {
                this.videoIsOpen = true;
            }
        }
    }
}
</script>